import { render } from "./Sportradar.vue?vue&type=template&id=e47bf37e"
import script from "./Sportradar.vue?vue&type=script&lang=js"
export * from "./Sportradar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__